<li class="list-item btn icon-l icon-left {{#if item.active}}ui-icon-check{{/if}}">
  <h3>Ref : {{item.reference}}</h3>
  <p>{{item.satelliteProviderName}}</p>
</li>
